import { useContext } from "react";
import { UserContext } from "./auth";

export const useAuth = () => {
  const context = useContext(UserContext);

  return context;
};
